module.exports = __webpack_public_path__ + "static/media/placek-mission.f13a13b2.webp";